import {ChevronDown} from 'lucide-react'
import { useState } from 'react'

interface FaqAccordionProps {
  faqs: { question: string, answer: string, badges: string[] }[]
  tone?: 'light' | 'dark'
}

function FaqAccordion({ faqs, tone = 'dark' }: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0)
  const isDark = tone === 'dark'

  return (
    <div className="space-y-3">
      {faqs.map((faq, index) => {
        const isOpen = openIndex === index
        return (
          <div
            key={faq.question}
            className={`overflow-hidden rounded-2xl border transition-colors ${
              isDark ? 'border-white/10 bg-white/[0.03]' : 'border-zinc-200 bg-zinc-50'
            }`}
          >
            <button
              type="button"
              onClick={() => setOpenIndex(isOpen ? null : index)}
              aria-expanded={isOpen}
              className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
            >
              <span className={`text-sm font-semibold sm:text-base ${isDark ? 'text-white' : 'text-zinc-900'}`}>
                {faq.question}
              </span>
              <ChevronDown
                className={`h-5 w-5 shrink-0 transition-transform ${isOpen ? 'rotate-180' : ''} ${
                  isDark ? 'text-[#8B5CF6]' : 'text-[#7C3AED]'
                }`}
              />
            </button>
            {isOpen ? (
              <div className="px-5 pb-5">
                <p className={`text-sm leading-relaxed ${isDark ? 'text-zinc-400' : 'text-zinc-600'}`}>
                  {faq.answer}
                </p>
                {faq.badges.length > 0 ? (
                  <div className="mt-3 flex flex-wrap gap-2">
                    {faq.badges.map(badge => (
                      <span
                        key={badge}
                        className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-medium ${
                          isDark ? 'bg-[#8B5CF6]/15 text-[#C4B5FD]' : 'bg-[#8B5CF6]/10 text-[#7C3AED]'
                        }`}
                      >
                        {badge}
                      </span>
                    ))}
                  </div>
                ) : null}
              </div>
            ) : null}
          </div>
        )
      })}
    </div>
  )
}

export default FaqAccordion
